/* globals lp,Class */
var BoxModule = Class.create(
  lp.ModuleBase,
  lp.ModuleElementMethods,
  lp.ModuleElementPropertiesPanelMethods
);

lp.addModule(new BoxModule({
  type:'lp-pom-box',
  isAllowedOnPage: function(page) {
    return page.getConfigValue('allowBoxWidget');
  },
  version:'1.0',
  name: 'Box',
  usageType:'page-widget',
  namespace: lp.module.box
}));



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-box/box_module.js
// module id = 513
// module chunks = 0 1